import React, { useState } from 'react';
import s from './ProgressBar.module.css'

interface ProgressBarProps {
  progressPercentage: string
}

const ProgressBar = ({ progressPercentage }: ProgressBarProps) => {
  const [style, setStyle] = useState({});

  setTimeout(() => {
    const newStyle = {
      opacity: 1,
      width: `${progressPercentage}%`
    }

    setStyle(newStyle);
  }, 200);

  return (
    <div className={s.progressBar}>
      <div className={s.progressBarProcess} style={style} />
    </div>
  )
}

export default ProgressBar
